import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  INovaplaceBusinessActionPayload,
  INovaplaceBusinessActionResponse,
  INovaplaceBusinessClosePayload,
  INovaplaceBusinessCloseResponse,
  INovaplaceBusinessContactsPayload,
  INovaplaceBusinessContactsResponse,
  INovaplaceBusinessFocusPayload,
  INovaplaceBusinessFocusResponse,
} from '@shared/components/banner/banner.models';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

const SHOPPING_API_URL = 'https://shopping-api.np.shopping/advertising-campaign/api/v1';
const jsonrpc = '2.0';

const generateId = (): string =>
  Array.from({ length: 20 }, () => Math.floor(Math.random() * 36).toString(36)).join('');

@Injectable({
  providedIn: 'root',
})
export class ShoppingApiService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {
  }

  get headers(): HttpHeaders {
    return new HttpHeaders({
      Authorization: `Bearer ${this.authService.token}`,
    });
  }

  get id(): { id: string } {
    return {
      id: generateId(),
    };
  }

  businessContacts(params: INovaplaceBusinessContactsPayload): Observable<INovaplaceBusinessContactsResponse> {
    return this.http.post<INovaplaceBusinessContactsResponse>(
      SHOPPING_API_URL,
      {
        method: 'businessContact',
        jsonrpc,
        params,
        ...this.id,
      },
      {
        headers: this.headers,
      },
    );
  }

  businessFocus(params: INovaplaceBusinessFocusPayload): Observable<INovaplaceBusinessFocusResponse> {
    return this.http.post<INovaplaceBusinessFocusResponse>(
      SHOPPING_API_URL,
      {
        method: 'businessFocus',
        jsonrpc,
        params,
        ...this.id,
      },
      {
        headers: this.headers,
      },
    );
  }

  businessAction(params: INovaplaceBusinessActionPayload): Observable<INovaplaceBusinessActionResponse> {
    return this.http.post<INovaplaceBusinessActionResponse>(
      SHOPPING_API_URL,
      {
        method: 'businessAction',
        jsonrpc,
        params,
        ...this.id,
      },
      {
        headers: this.headers,
      },
    );
  }

  businessClose(params: INovaplaceBusinessClosePayload): Observable<INovaplaceBusinessCloseResponse> {
    return this.http.post<INovaplaceBusinessCloseResponse>(
      SHOPPING_API_URL,
      {
        method: 'businessClose',
        jsonrpc,
        params,
        ...this.id,
      },
      {
        headers: this.headers,
      },
    );
  }
}
